// tableService.js corregido
import axios from "axios";
import { handleApiError } from "../utils/errorHandler";
import config from "../config/config";

const BASE_URL = `${config.apiUrl}/api/table`;

export const tableService = {
  async listTables() {
    try {
      const response = await axios.get(`${BASE_URL}/listTables`);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message || "Mesas obtenidas exitosamente",
      };
    } catch (error) {
      const apiError = handleApiError(error);
      return {
        success: false,
        data: null,
        message: apiError.message,
      };
    }
  },

  // Agrupar mesas por ubicación
  groupTablesByLocation(tables) {
    return tables.reduce((grouped, table) => {
      const location = table.ubication || "Sin ubicación";
      if (!grouped[location]) {
        grouped[location] = [];
      }
      grouped[location].push({
        id: table.mesaId,
        descriptionMesa: table.descriptionMesa,
        hasOrders: table.tableStatus === "EN CURSO",
        cantAsientos: table.cantAsientos,
        joinTable: table.joinTable,
      });
      return grouped;
    }, {});
  },

  // Obtener ubicaciones únicas de las mesas
  getUniqueLocations(tables) {
    return [
      ...new Set(tables.map((table) => table.ubication || "Sin ubicación")),
    ];
  },

  async registerTable(tableData) {
    try {
      const data = {
        ...tableData,
        tableStatus: tableData.tableStatus || "CREADA",
        joinTable: tableData.joinTable || "NO",
        cartData: [],
        joinTablesId: {},
        isVirtualTable: tableData.isVirtualTable || "NO",
      };

      const response = await axios.post(`${BASE_URL}/registerTable`, data);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message || "Mesa registrada exitosamente",
      };
    } catch (error) {
      const apiError = handleApiError(error);
      return {
        success: false,
        data: null,
        message: apiError.message,
      };
    }
  },

  async deleteTable(tableId) {
    try {
      const response = await axios.delete(`${BASE_URL}/deleteTable/${tableId}`);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message || "Mesa eliminada exitosamente",
      };
    } catch (error) {
      const apiError = handleApiError(error);
      return {
        success: false,
        data: null,
        message: apiError.message,
      };
    }
  },

  async joinTables(mesasIds) {
    try {
      console.log("Datos enviados en el servicio:", mesasIds);
      const response = await axios.post(`${BASE_URL}/joinTables`, mesasIds);
      return {
        success: true,
        data: response.data.data,
        message: response.data.message || "Mesas unidas exitosamente",
      };
    } catch (error) {
      const apiError = handleApiError(error);
      return {
        success: false,
        data: null,
        message: apiError.message,
      };
    }
  },

  async separateTables(tableId) {
    try {
      const response = await axios.post(
        `${BASE_URL}/separateTables/${tableId}`
      );
      return {
        success: true,
        data: response.data.data,
        message: response.data.message || "Mesas separadas exitosamente",
      };
    } catch (error) {
      const apiError = handleApiError(error);
      return {
        success: false,
        data: null,
        message: apiError.message,
      };
    }
  },

  async updateTableStatus(tableId, status) {
    try {
      const response = await axios.put(`${BASE_URL}/updateStatus/${tableId}`, {
        tableStatus: status,
      });
      return {
        success: true,
        data: response.data.data,
        message:
          response.data.message || "Estado de mesa actualizado exitosamente",
      };
    } catch (error) {
      const apiError = handleApiError(error);
      return {
        success: false,
        data: null,
        message: apiError.message,
      };
    }
  },
};
